import type { KassaListParams } from '../model/types';

export const KASSA_KEYS = {
  all: ['kassa'] as const,
  list: (params?: KassaListParams) => [...KASSA_KEYS.all, 'list', params] as const,
};
